goog.provide("shadow.js.shim.module$$mui$material$Stepper");
goog.provide("module$shadow_js_shim_module$$mui$material$Stepper");
shadow.js.shim.module$$mui$material$Stepper = shadow.js.nativeProvides["@mui/material/Stepper"] = shadow$bridge("@mui/material/Stepper");
module$shadow_js_shim_module$$mui$material$Stepper.default = shadow.js.shim.module$$mui$material$Stepper;
